import React from 'react';
import AppIcon from '@icons/app-icon';

const EntityTypeIcon = props => <AppIcon app="map" {...props} />;

export default EntityTypeIcon;
